"use strict";

exports.__esModule = true;
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _logo = _interopRequireDefault(require("./logo"));

var _ = require("../..");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _templateObject6() {
  var data = _taggedTemplateLiteralLoose(["\n  padding: 0 1rem;\n  cursor: pointer;\n  display: inline-block;\n  &:focus {\n    outline: none;\n  }\n"]);

  _templateObject6 = function _templateObject6() {
    return data;
  };

  return data;
}

function _templateObject5() {
  var data = _taggedTemplateLiteralLoose(["\n  width: inherit;\n"]);

  _templateObject5 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4() {
  var data = _taggedTemplateLiteralLoose(["\n  width: 100%;\n  max-width: 16rem;\n  @media (min-width: 320px) {\n    transform: translateX(-8%);\n  }\n  @media (min-width: 360px) {\n    transform: translateX(-20%);\n  }\n  @media (min-width: 375px) {\n    transform: translateX(-25%);\n  }\n  @media (min-width: 384px) {\n    transform: translateX(-28%);\n  }\n  @media (min-width: 400px) {\n    transform: translateX(-31%);\n  }\n  @media (min-width: 411px) {\n    transform: translateX(-34%);\n  }\n  @media (min-width: 480px) {\n    transform: none;\n  }\n  @media (min-width: 768px) {\n    /* transform: none;\n    max-width: 24rem;\n    height: 5.6rem;*/\n  }\n  @media (min-width: 1024px) {\n    max-width: 16rem;\n    height: auto;\n  }\n"]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = _taggedTemplateLiteralLoose(["\n  margin: 0 auto;\n  display: none;\n  flex-direction: row;\n  align-items: center;\n  justify-content: space-between;\n  max-width: 140rem;\n  padding: 0 0.6rem;\n  height: 6.6rem;\n  @media (max-width: 1023px) {\n    display: flex;\n  }\n"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteralLoose(["\n  margin: 0 auto;\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  justify-content: space-between;\n  max-width: 140rem;\n  height: auto;\n  padding: 2rem 0rem;\n  @media (max-width: 1023px) {\n    display: none;\n  }\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteralLoose(["\n  background-color: #c2171d;\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteralLoose(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }

  strings.raw = raw;
  return strings;
}

var HeaderContainer = _styledComponents["default"].div(_templateObject());

var WebHeaderContent = _styledComponents["default"].div(_templateObject2());

var MobileHeaderContent = _styledComponents["default"].div(_templateObject3());

var LogoContainer = _styledComponents["default"].div(_templateObject4());

var LogoLink = _styledComponents["default"].a(_templateObject5());

var Icon = _styledComponents["default"].div(_templateObject6());

var Header = function Header(props) {
  var _props$logoLink = props.logoLink,
      logoLink = _props$logoLink === void 0 ? "#" : _props$logoLink,
      _props$searchClick = props.searchClick,
      searchClick = _props$searchClick === void 0 ? function () {} : _props$searchClick,
      _props$cartClick = props.cartClick,
      cartClick = _props$cartClick === void 0 ? function () {} : _props$cartClick,
      leftContent = props.leftContent,
      logo = props.logo,
      logoMobile = props.logoMobile,
      rightContent = props.rightContent,
      mobileCart = props.mobileCart;
  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(HeaderContainer, null, /*#__PURE__*/_react["default"].createElement(WebHeaderContent, null, leftContent, logo && logo || /*#__PURE__*/_react["default"].createElement(LogoContainer, null, /*#__PURE__*/_react["default"].createElement(LogoLink, {
    href: logoLink
  }, /*#__PURE__*/_react["default"].createElement(_logo["default"], null))), rightContent), /*#__PURE__*/_react["default"].createElement(MobileHeaderContent, null, leftContent, " ", logoMobile && logoMobile || /*#__PURE__*/_react["default"].createElement(LogoContainer, null, /*#__PURE__*/_react["default"].createElement(LogoLink, {
    href: logoLink
  }, /*#__PURE__*/_react["default"].createElement(_logo["default"], null))), /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement(Icon, {
    onClick: searchClick
  }, /*#__PURE__*/_react["default"].createElement(_.Search, {
    color: "#fff"
  })), mobileCart ? mobileCart : /*#__PURE__*/_react["default"].createElement(Icon, {
    onClick: cartClick
  }, /*#__PURE__*/_react["default"].createElement(_.Bag, {
    color: "#fff"
  }))))));
};

var _default = Header;
exports["default"] = _default;
module.exports = exports["default"];